















































































































































import Vue, { PropType } from "vue";

import { Data, Methods, Computed, Props } from "./types";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import Suffix from "@/components/Atoms/Typography/Suffix/index.vue";
import Caption from "@/components/Atoms/Typography/Caption/index.vue";
import TextArea from "@/components/Atoms/Forms/TextArea/index.vue";
import LayoutColumnDouble from "@/components/Atoms/Layout/ColumnDouble/index.vue";
import ConfirmResetView from "./Organisms/ConfirmResetmailTemplate/index.vue";
import LineClamp from "@/components/Atoms/Typography/LineClamp/index.vue";
import EmptyView from "@/components/Atoms/EmptyView/index.vue";
import LoadingView from "@/components/Molecules/LoadingView/index.vue";

import dayjs from "dayjs";
import copy from "copy-to-clipboard";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "ReviewOffers",
  components: {
    Heading,
    Suffix,
    Caption,
    TextArea,
    LayoutColumnDouble,
    ConfirmResetView,
    LineClamp,
    EmptyView,
    LoadingView
  },
  props: {
    isLoadingOnFetch: {
      type: Boolean as PropType<Props["isLoadingOnFetch"]>,
      required: true
    },
    isLoadingOnSave: {
      type: Boolean as PropType<Props["isLoadingOnSave"]>,
      required: true
    },
    offers: {
      type: Object as PropType<Props["offers"]>,
      default: undefined
    },
    selectedOfferDetail: {
      type: Object as PropType<Props["selectedOfferDetail"]>,
      default: undefined
    },
    selectedOfferId: {
      type: Number as PropType<Props["selectedOfferId"]>,
      default: undefined
    }
  },
  data() {
    return {
      isShowResetConfirmModal: false
    };
  },
  computed: {
    linkDescription() {
      const typeName = this.selectedOfferDetail?.type_name;
      if (!typeName) return "";

      if (new RegExp("^説明会用").test(typeName)) {
        return `説明会に参加した学生が投稿できます`;
      }
      if (new RegExp("^インターン").test(typeName)) {
        return `インターンに参加した学生が投稿できます`;
      }
      if (new RegExp("^最終選考参加者用").test(typeName)) {
        return `最終選考に参加した学生が投稿できます（最終選考の当落は不問です）`;
      }

      return "";
    },
    statusMessage() {
      if (this.isLoadingOnSave) {
        return "保存しています...";
      }

      if (this.selectedOfferDetail?.lastUpdatedAt) {
        return `自動保存しました   最終編集：${dayjs(
          this.selectedOfferDetail?.lastUpdatedAt
        ).fromNow()}`;
      }

      return "";
    },
    isEmpty() {
      return !this.offers?.content_offers.length && !this.isLoadingOnFetch;
    }
  },
  methods: {
    onClickMenu(offerId) {
      this.$emit("onClickMenu", offerId);
    },
    onClickCopyURL() {
      copy(this.selectedOfferDetail?.content_offer_url || "");
    },
    onClickCopyMailTemplate() {
      copy(this.selectedOfferDetail?.mail_body || "");
    },
    onClickResetMailTemplate() {
      this.toggleResetConfirmModal();
    },
    onCloseResetConfirmModal() {
      this.toggleResetConfirmModal();
    },
    onClickResetMailTemplateConfirm() {
      this.toggleResetConfirmModal();
      this.$emit("onClickResetMailTemplateConfirm");
    },
    onChangeMailTemplate(text) {
      this.$emit("onChangeMailTemplate", text);
    },
    toggleResetConfirmModal() {
      this.isShowResetConfirmModal = !this.isShowResetConfirmModal;
    }
  }
});
